import React from 'react'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faExclamationCircle} from '@fortawesome/free-solid-svg-icons'

export default function RevokedView() {
  return (
    <div className="flex flex-col justify-center items-center flex-grow">
      <div className="flex flex-col justify-center items-center bg-error rounded-full h-32 w-32">
        <FontAwesomeIcon
          icon={faExclamationCircle}
          className="text-7xl text-white"
        />
      </div>
      <h1 className="text-center text-4xl mt-8">
        Your digital key <br />
        access has been <br />
        revoked.
      </h1>
      <p className="text-center text-xl leading-tight mt-8">
        Please see Scout Livin Staff <br />
        on the second floor.
      </p>
    </div>
  )
}
